"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ironOreStorageConfig = void 0;
exports.ironOreStorageConfig = {
    name: 'storage-iron-ore',
    fullname: 'Iron Ore Storage',
    description: 'Storage for iron ore, keeping it at the perfect humidity and temperature.',
    type: 'storage',
    width: 1,
    height: 1,
    levelMax: 9,
    canBeDisabled: false,
    requiredTechnology: 'ores',
    levels: [
        { level: 0, constructionCosts: {}, time: 1, provides: {}, costs: {}, stores: { 'iron-ore': 10 } },
        { level: 1, constructionCosts: { iron: 5 }, time: 1, provides: {}, costs: {}, stores: { 'iron-ore': 20 } },
        { level: 2, constructionCosts: { iron: 10 }, time: 1, provides: {}, costs: {}, stores: { 'iron-ore': 40 } },
        { level: 3, constructionCosts: { iron: 30 }, time: 1, provides: {}, costs: {}, stores: { 'iron-ore': 100 } },
        { level: 4, constructionCosts: { iron: 70 }, time: 1, provides: {}, costs: {}, stores: { 'iron-ore': 200 } },
        { level: 5, constructionCosts: { iron: 150 }, time: 1, provides: {}, costs: {}, stores: { 'iron-ore': 400 } },
        { level: 6, constructionCosts: { iron: 300 }, time: 1, provides: {}, costs: {}, stores: { 'iron-ore': 1000 } },
        { level: 7, constructionCosts: { iron: 500 }, time: 1, provides: {}, costs: {}, stores: { 'iron-ore': 2000 } },
        { level: 8, constructionCosts: { iron: 1000 }, time: 1, provides: {}, costs: {}, stores: { 'iron-ore': 3000 } },
        { level: 9, constructionCosts: { iron: 2000 }, time: 1, provides: {}, costs: {}, stores: { 'iron-ore': 5000 } },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/ironorestorage.js
// module id = 5f/7
// module chunks = 0